import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

const SAO_PAULO_TZ = 'America/Sao_Paulo';

/** Resultado do normalizador em `transformApiResponseDates.js` (evita converter duas vezes). */
export const BRASILIA_WALL_CLOCK_DATETIME_RE = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

/** API timestamps without offset are treated as UTC (GMT+0). */
function parseApiDateAsUtc(dateString) {
  if (!dateString) return null;
  let s = String(dateString).trim();
  if (!s) return null;
  if (BRASILIA_WALL_CLOCK_DATETIME_RE.test(s)) {
    return null;
  }
  if (s.includes(' ') && !s.includes('T')) {
    s = s.replace(' ', 'T');
  }
  const hasExplicitTz =
    /Z$/i.test(s) || /[+-]\d{2}:\d{2}$/.test(s) || /[+-]\d{4}$/.test(s);
  const d = new Date(hasExplicitTz ? s : `${s}Z`);
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * Exibe data/hora da API (UTC) no fuso de Brasília (America/Sao_Paulo).
 * Formato: YYYY-MM-DD HH:mm:ss
 */
export function formatUtcDateTimeAsSaoPaulo(dateString) {
  if (!dateString) return '';
  const trimmed = String(dateString).trim();
  if (BRASILIA_WALL_CLOCK_DATETIME_RE.test(trimmed)) {
    return trimmed;
  }

  const d = parseApiDateAsUtc(dateString);
  if (!d) return '';

  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: SAO_PAULO_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(d);

  const get = (type) => parts.find((p) => p.type === type)?.value ?? '';
  const y = get('year');
  const mo = get('month');
  const da = get('day');
  const h = get('hour');
  const mi = get('minute');
  const se = get('second');
  if (!y) return '';
  return `${y}-${mo}-${da} ${h}:${mi}:${se}`;
}

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}
